// extracted by mini-css-extract-plugin
export default {"name":"NamePanel_name__lR0Iy","nameInput":"NamePanel_nameInput__xtB5a","editIcon":"NamePanel_editIcon__YNu5M"};